<template>
  <div id="login" v-if="isShowLoginView">
    <div class="login-title"> {{ $t("message.scan_code") }}</div>
    <QRCodeVue3 :width="250" :height="250" :value="qrLink" myclass="qrcode"
      image="data:image/png;base64,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"
      :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'Q' }"
      :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }" :dotsOptions="{
    type: 'square',
    color: '#007bff',
    gradient: null,
  }" :backgroundOptions="{ color: '#ffffff' }" :cornersSquareOptions="{ type: 'square', color: '#007bff' }"
      :cornersDotOptions="{ type: undefined, color: '#007bff' }" fileExt="png" :download="false" />
    <div class="login-time">{{ $t("message.expiration_time") }} {{ expirationTime }}</div>
    <button class="login-refresh w-10 btn btn-lg btn-primary" @click="getLoginQrCode"> <svg
        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise"
        viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
      </svg> {{ $t("message.refresh") }}</button>

    <div class="login-cancel" @click="cancelLogin"> {{ $t("message.cancel_login") }}</div>
  </div>
  <div class="humberger__menu__wrapper" :class="{ 'show__humberger__menu__wrapper': isMenuVisible }">
    <div class="humberger__menu__logo"><a><img src="../assets/images/site-logo1.png" alt=""></a></div>
    <div class="humberger__menu__cart">
      <div class="header__cart__price">
        <img src="../assets/images/vip.png">
        {{ vipTime == "" ? $t('message.be_member') : ($t('message.vaild_date')) }} {{ vipTime }}
      </div>
      <div class="header__cart__price" style="margin-top: 10px;">
        <img src="../assets/images/ticket-num.png">
        {{ $t('message.ticket_count') }}{{ ticketCount }}
      </div>
    </div>
    <div class="humberger__menu__widget">
      <div class="header__top__right__language">
        <div>{{ $t("message.language") }}</div><span class="arrow_carrot-down"></span>
        <ul>
          <li @click="switchLocale('zh-hk')">{{ $t('message.zh_hk') }}</li>
          <li @click="switchLocale('en')">{{ $t('message.en') }}</li>
        </ul>
      </div>
      <div class="header__top__right__auth"><a @click="loginOrLogout" style="margin-left:15px ;"> <svg
            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill"
            viewBox="0 0 16 16">
            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
          </svg> {{ isLogined() ? $t('message.logout') : $t('message.login') }}</a></div>
    </div>
    <nav class="mobile-menu">
      <ul>
        <li><a href="#home">{{ $t('message.home') }}</a></li>
        <li><a href="#download">{{ $t('message.download') }}</a></li>
        <li>
          <a href="#purchase">{{ $t('message.purchase') }}</a>
        </li>
        <li>
          <a href="#contact">{{ $t('message.contact') }}</a>

        </li>
      </ul>
    </nav>

  </div>
  <div class="humberger__menu__overlay" :class="{ active: isMenuVisible }" @click="toggleMenu">




  </div>
  <div id="preloder" v-if="isLoading">
    <div class="loader"></div>
  </div>

  <div class="home" v-else>
    <header class="header">
      <div class="header__top">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="header__top__left">
                <ul>
                  <li>{{ $t('message.customer') }}</li>
                  <li> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-envelope-at" viewBox="0 0 16 16">
                      <path
                        d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                      <path
                        d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                    </svg>
                    {{ email.replace('@', "(at)") }}</li>

                </ul>
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div class="header__top__right">

                <div class="header__top__right__language">
                  <div>{{ $t("message.language") }}</div><span class="arrow_carrot-down"></span>
                  <ul>
                    <li @click="switchLocale('zh-hk')">{{ $t('message.zh_hk') }}</li>
                    <li @click="switchLocale('en')">{{ $t('message.en') }}</li>
                  </ul>
                </div>
                <div class="header__top__right__auth"><a href="#" @click="loginOrLogout"><svg
                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-person-fill" viewBox="0 0 16 16">
                      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                    </svg> {{ isLogined() ? $t('message.logout') : $t('message.login') }}</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="header__logo">
              <a href=""><img src="../assets/images/site-logo1.png" alt="" /></a>
            </div>
          </div>
          <div class="col-xl-6 col-lg-9">
            <nav class="header__menu">
              <ul>
                <li><a href="#home">{{ $t('message.home') }}</a></li>

                <li><a href="#download">{{ $t('message.download') }}</a></li>
                <li>
                  <a href="#purchase">{{ $t('message.purchase') }}</a>

                </li>
                <li>
                  <a href="#contact">{{ $t('message.contact') }}</a>

                </li>
              </ul>
            </nav>
          </div>
          <div class="col-lg-3">
            <div class="header__cart">


              <div class="header__cart__price">
                <img src="../assets/images/vip.png">
                {{ vipTime == "" ? $t('message.be_member') : ($t('message.vaild_date')) }}{{ vipTime }}
              </div>

              <div class="header__cart__price">
                <img src="../assets/images/ticket-num.png">
                {{ $t('message.ticket_count') }} {{ ticketCount }}
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-3">
            <div class="header__cart">
              <div class="header__cart__price">

                <a href="#" class="primary-btn" @click="loginOrLogout">{{ checkLogin() ? "Logout" : "Login" }}</a>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div class="humberger__open"><i class="fa fa-bars"></i></div> -->
      </div>
    </header>
    <div class="overlay"></div>
    <section class="hero hero-normal" id="home">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="hero__text"><span class="offer-span">{{ $t('message.enjoy') }}</span>
              <h2><span class="hero-span">Ladder VPN</span></h2>
              <p>{{ $t('message.enjoy_title') }}</p>
              <a class="primary-btn" href="#download">{{ $t('message.download') }}</a>
              <a class="purchase-btn" href="#purchase">{{ $t('message.purchase') }}</a>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="about-btn-list-home">
              <a :href="androidDownloadUrl" v-if="isAndroid || isOther" style="margin-top: 12px;">
                          <img src="../assets/images/img32.png" alt="">
                        </a>
                        <!-- for apple store -->
                        <a :href="iosDownloadUrl" v-if="isIOS || isOther" style="margin-top: 12px;">
                          <img src="../assets/images/img33.png" alt="">
                        </a>
                        <a :href="windowsDownloadUrl" style="margin-top: 12px; display: inline-block; cursor: pointer;"
                          @click="handleWindowsDownload">
                          <img src="../assets/images/img34.png" alt="Download">
                        </a>
            </div>
            <figure class="banner-image" style="margin-top: 12px;">
              <img src="../assets/images/img1.png" alt="">
            </figure>


          </div>
        </div>
        <div class="humberger__open" @click="toggleMenu">

          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style="margin-top: 4px;" fill="currentColor"
            class="bi bi-list-stars" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z" />
            <path
              d="M2.242 2.194a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.256-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53z" />
          </svg>

        </div>

      </div>


    </section>

    <section class="latest-product section-padding-100-0" id="download">
      <div class="container">
        <div class="row">
          <div class="col-lg-12" data-v-df02a584="">
            <div class="section-title" data-v-df02a584="">
              <h2 data-v-df02a584="">{{ $t("message.download") }}</h2>
            </div>
          </div>

          <div class="callback-section primary-bg-callback">
            <div class="container">
              <div class="callback-inner">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <figure id="download" class="callback-image">
                      <img src="../assets/images/img6.png" alt="">
                    </figure>
                  </div>
                  <div class="col-md-6">

                    <div class="download">
                      <p>{{ $t("message.choose_platform") }}</p>
                      <h1>{{ $t("message.check_out") }}</h1>
                      <h3>{{ $t("message.faster_safer") }}</h3>
                      <div class="about-btn-list">
                        <a :href="androidDownloadUrl" v-if="isAndroid || isOther" style="margin-top: 12px;">
                          <img src="../assets/images/img32.png" alt="">
                        </a>
                        <!-- for apple store -->
                        <a :href="iosDownloadUrl" v-if="isIOS || isOther" style="margin-top: 12px;">
                          <img src="../assets/images/img33.png" alt="">
                        </a>
                        <a :href="windowsDownloadUrl" style="margin-top: 12px; display: inline-block; cursor: pointer;"
                          @click="handleWindowsDownload">
                          <img src="../assets/images/img34.png" alt="Download">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overlay"></div>
              </div>
            </div>
          </div>

        </div>
        <div class="overlay"></div>
      </div>
    </section>


    <section class="featured section-padding-85-0" id="purchase">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h2>{{ $t("message.purchase") }}</h2>
            </div>
            <div class="featured__controls">
              <ul>
                <li :class="{ active: goodsIndex == 0 }" @click="updateCurrentList('trial')">{{ $t("message.trial") }}
                </li>
                <li :class="{ active: goodsIndex == 1 }" @click=" updateCurrentList('member')">{{ $t("message.member")
                  }}
                </li>
                <li :class="{ active: goodsIndex == 2 }" @click=" updateCurrentList('ticket')">{{ $t("message.ticket")
                  }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row featured__filter">

          <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mix " v-for="goods in currentList" :key="goods.productId"
            :class="{ selected: selectIds[goodsIndex] == goods.productId }">
            <div class="featured__item">
              <div class="featured__item__title">
                {{ formatDayVipName(goods.days) }}
              </div>
              <div class="item-img">
                <img src="../assets/images/trial.png" v-if="goodsIndex == 0">
                <img src="../assets/images/member.png" v-else-if="goodsIndex == 1">
                <img src="../assets/images/ticket.png" v-else>

              </div>

              <div class="item-details">
                <div class="item-pri">
                  <p>U.S${{ goods.price }}</p>
                  <h5 v-if="goods.origPrice">U.S$<span>{{ goods.origPrice }}</span></h5>
                </div>
                <div class="impressions">{{ formatDayOrNum(goods) }}</div>
              </div>
              <div class="featured__item__text">
                <h6 style="color: crimson;">
                  {{ getLocalTips(goods) }}
                </h6>
                <h6>
                  {{ $t("message.unlimited_bandwidth") }}
                </h6>
                <h6>
                  {{ $t("message.emali_support") }}
                </h6>

              </div>
              <div class="col-sm-12 text-center" @click="toBuyGoodsByButton(goods)">
                <a class="b-blue-btn load-more">
                  <span v-if="goods.isLoading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                  {{ $t("message.purchase") }}</a>
              </div>
            </div>
          </div>

        </div>
        <div class="overlay"></div>
      </div>

    </section>
    <PayModal ref="payRef">

    </PayModal>

    <div class="overlay" style="top:60%"></div>
    <footer class="footer spad" id="contact">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <div class="footer__about">
              <div class="footer__about__logo">
                <a href=""><img src="../assets/images/site-logo1.png" alt="" /></a>
              </div>
              <div>
                {{ $t("message.product_desc") }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 ">
            <div class="footer__widget">
              <h6>{{ $t("message.quick_links") }}</h6>
              <ul>
                <li><a href="#purchase"> {{ $t("message.purchase") }}</a></li>
                <li><a href="#contact">{{ $t("message.contact") }}</a></li>
              </ul>

            </div>
          </div>
          <div class="col-lg-3 col-md-12">
            <div class="footer__widget">
              <h6>{{ $t("message.contact_info") }}</h6>
              <p>{{ $t("message.customer_support") }}
              </p>
              <div class="textwidget widget-text">
                <a :href="'mailto:' + email">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-envelope-at" viewBox="0 0 16 16">
                    <path
                      d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                    <path
                      d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                  </svg>
                  {{ email.replace('@', "(at)") }}

                </a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-12">
            <div class="footer__widget">
              <h6>{{ $t("message.download") }}</h6>
              <a :href="androidDownloadUrl">
                <img src="../assets/images/img32.png">
              </a>
              <a :href="iosDownloadUrl">
                <img src="../assets/images/img33.png">
              </a>
              <a :href="windowsDownloadUrl" style=" display: inline-block; cursor: pointer;"
                @click="handleWindowsDownload">
                <img src="../assets/images/img34.png" alt="Download">
              </a>
              <DownloadModal ref="downloadRef" />
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="copy-right" style="text-align: center;">Copyright © 2023 ABS. Tech Inc. All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import QRCodeVue3 from "qrcode-vue3";
import { home } from "@/plugins/home"
import PayModal from "@/components/modal/PayModal.vue"
import DownloadModal from "@/components/modal/DownloadModal.vue"
// import { intercomService } from '@/plugins/intercomService';
// import { useEncryptedFieldsStorage } from "@/plugins/encryptedFieldsStorage";
// const listenerStore = useEncryptedFieldsStorage();
// listenerStore.initializeListeners();
// intercomService.load();
const {
  isLoading,
  isMenuVisible,
  isShowLoginView,
  ticketCount,
  vipTime,
  currentList,
  goodsIndex,
  selectIds,
  isAndroid,
  isIOS,
  isOther,
  qrLink,
  expirationTime,
  payRef,
  downloadRef,
  androidDownloadUrl,
  iosDownloadUrl,
  windowsDownloadUrl,
  email,
  handleWindowsDownload,
  getHwid,
  switchLocale,
  toggleMenu,
  cancelLogin,
  loginOrLogout,
  getLoginQrCode,
  getPackages,
  updateCurrentList,
  getUserInfo,
  checkClient,
  formatDayOrNum,
  formatDayVipName,
  checkAndLogin,
  isLogined,
  toBuyGoodsByButton,
  getResourceUrls,
  getLocalTips,
  setFacebookCookies,
} = home()

onMounted(async () => {

  checkClient()
  setFacebookCookies()
  // 硬件id用这个
  await getHwid()
  // 取token，发loginByToken
  await checkAndLogin()

  getPackages()
  getResourceUrls()
  // 检查是否登录成功
  if (isLogined()) {
    getUserInfo()

  }
  else {
    ticketCount.value = " 0"
    vipTime.value = ""
  }

});


</script>



<style scoped>
.fade-out {
  transition: opacity 1s;
  opacity: 0;
}

.overlay {
  background-image: url(../assets/images/banner-pattern.png);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.container .overlay {
  background-image: url(../assets/images/banner-pattern.png);
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  border-radius: 25px;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -ms-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
  z-index: -1;
}

.about-btn-list a img {
  width: 200px;
  height: 80px;
  max-width: 200px;

}

.about-btn-list-home a img {
  width: 210px;
  height: 82px;
  max-width: 210px;
}

.banner-image img {
  width: 100%;
  max-width: 400px;
}
</style>
@/plugins/home